import { DateService } from 'Services';
import { getCustomUserName } from './users';

export const transformDeploymentHistoryData = (data: Deployment[], users?: UsersHashmap) => {
    return data.map((dataItem) => {
        const { id, version, comment, summary, createdBy, createdAt } = dataItem;
        const { acquirerSummary, merchantSummary, tenantGroupSummary } = summary;

        const newHistory: DeploymentHistoryData = {
            id,
            comment,
            version: String(version),
            createdAt,
            createdBy,
            addedRules: acquirerSummary?.addedRules,
            modifiedGlobalRules: acquirerSummary?.modifiedRules,
            newMerchants: merchantSummary?.added,
            modifiedMerchants: merchantSummary?.modified,
            deactivatedMerchants: merchantSummary?.disabled,
            newTenantGroups: tenantGroupSummary?.added,
            modifiedTenantGroups: tenantGroupSummary?.modified,
            removedTenantGroups: tenantGroupSummary?.removed,
            _formatted: {
                createdAt: DateService.getDateTime(createdAt),
                createdBy: getCustomUserName(createdBy, users)
            }
        };

        return newHistory;
    });
};
